import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useGlobalController } from "@bcm-dev/bcms-vite";
import TransferConfirmPage, { getDefaultPageData } from "components/pages/TransferConfirmPage";
import Classes, { Account } from "model";

/**
 * @name CaptureTransfersTransferSuccess
 * @returns {React.Component}
 * @description The capture component for the transfer confirm page with the from, to
 * amount and description values filled out.
 * This capture is used in the following capture groups:
 * "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersTransferSuccess(props) {
    // Initalize all model classes
    const globalController = useGlobalController();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const checkingAccount = Account.getDefaultBrandedAccountByType("checking");
    const savingsAccount = Account.getDefaultBrandedAccountByType("savings");
    // Initalize a new instance of BCMSStateManagerCRUD with the default page data
    // updatng the from, to, amount and description properties of the transfer
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "transfer", "from" ],checkingAccount)
        .update([ "transfer", "to" ], savingsAccount)
        .update([ "transfer", "amount" ], 100)
        .update([ "transfer", "schedule" ], "Recurring")
        .update([ "transfer", "frequency" ], "Monthly")
        .update([ "transfer", "startDate" ], BCMSDate.init())
        .update([ "transfer", "estimatedDeliveryDate" ], BCMSDate.init())
        .update([ "transfer", "duration" ], "No End Date")
        .update([ "transfer", "description" ], "Sample")
        .submit();

    // Return the TransferConfirmPage passing the data variable
    return <TransferConfirmPage data={ data } className="for-capture"/>
}